import { render, staticRenderFns } from "./SignInNotSupportedDialog.vue?vue&type=template&id=1040c094"
import script from "./SignInNotSupportedDialog.vue?vue&type=script&lang=js"
export * from "./SignInNotSupportedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports